import { gql } from "@apollo/client";

export const CHANGE_STATE_FRECUENCIA_DISTRIBUIDOR = gql`
    mutation changeStateFrecuenciaDistribuidor(        
            $idFrecuenciaDistribuidor: Int!
            $state: Boolean!
         ){
        changeStateFrecuenciaDistribuidor(
            idFrecuenciaDistribuidor : $idFrecuenciaDistribuidor,
            state : $state
        ) {
            idFrecuenciaDistribuidor
        }
    }
`;